import { OccurenceType } from './occurence-type.model';

export class DateOccurrenceType {

    id: number;
    occurrenceType: OccurenceType;
    occurrenceId: number;
    updateDateTime: Date;
    suggestedDate: Date;
    approvedDate: Date;

    constructor(id: number, occurrenceType: OccurenceType, occurrenceId: number, updateDateTime: Date, suggestedDate: Date, approvedDate: Date) {
        this.id = id;
        this.occurrenceType = occurrenceType;
        this.occurrenceId = occurrenceId;
        this.updateDateTime = updateDateTime;
        this.suggestedDate = suggestedDate;
        this.approvedDate = approvedDate;
    }
}